// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__LMP_8","paragraph":"style_paragraph__31Q2j","isBold":"style_isBold__CxMcS","link":"style_link__dqzFj"};